/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { SalesAgreementProductLine } from "../storage";

// Note: only new argeement has schedule
export const hasSchedule = (lines: SalesAgreementProductLine[]) =>
  lines.some((l) => l.scheduledDate);
